export default __webpack_public_path__ + "static/rematriculas-0c6974c358349a715dc73036a724b2df.png";